import { render } from "./PlantInformation.vue?vue&type=template&id=75f50e1e"
import script from "./PlantInformation.vue?vue&type=script&lang=js"
export * from "./PlantInformation.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/jalizan/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__